// import Header from '../../components/Header/Header';
import { useEffect, useState } from 'react';
import Menu from '../../components/Menu/Menu';
import './Home.scss';
export default function Home() {

    return (
        <div id="home">
            <div className='centered-container'>
                <Menu title="Ratonera" options={[
                    { name: 'Lists', path: '/lists', visible: ({ user }) => (user?.roles?.includes('developer') || user?.roles?.includes('lists')) },
                    { name: 'Tokipona', path: '/tokipona', visible: ({ user }) => user?.roles?.length > 0 },
                    { name: 'Telegram', path: '/telegram', visible: ({ user }) => user?.roles?.length > 0 },
                    { name: 'Misc', path: '/misc', visible: ({ user }) => user?.roles?.includes('developer') },
                    { name: 'About', path: '/about' },
                ]} />
            </div>
        </div>
    );
}
// scp -P 4022 -r build david@rattonera.duckdns.org:/home/david/tmp